import { styled } from "@mui/material/styles";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Fragment } from "preact";
import ProfilePicture from "../../assets/defaultImg.jpg";

// import { clearSessionStorage, getSessionStorage } from "../../utils";
import MenuIcon from "@mui/icons-material/Menu";
import { useEffect, useRef, useState } from "preact/hooks";
import { Close } from "@mui/icons-material";
import { Badge, IconButton } from "@mui/material";
import Logo from "../../assets/logo.png";
import HomeIcon from "@mui/icons-material/Home";
import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import AddBoxIcon from "@mui/icons-material/AddBox";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import LogoutIcon from "@mui/icons-material/Logout";
import { route } from "preact-router";
import QueueMusicIcon from "@mui/icons-material/QueueMusic";
import useApi from "../../hooks/useApi";
import {
  liveVenueApi,
  logoutApi,
  profileApi,
} from "../../api/controller/accounts";
import {
  clearSessionStorage,
  getSessionStorage,
  removeCookie,
  setSessionStorage,
} from "../../utils";
import { useOnClickOutside } from "usehooks-ts";

const ContentWrapper = styled("div")`
  padding: 10px 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .leftText {
    color: #f7f7f7;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
  }
  .rightText {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #f7f7f7;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;
  }

  .notificationsIcon {
    // margin-left: 20px;
  }
  .menuIcon {
    color: white;
    display: none;
    padding-right: 6px;
  }
  .nav-menu {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    width: 100%;
    background-color: rgba(28, 28, 30, 0.95);
    color: white;
    position: fixed;
    top: 0;
    left: 0;
    height: 380px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    z-index: 9999;
  }
  .userRoutes {
    text-align: center;
  }
  .userStateRoutes {
    width: 100%;
  }

  .navbarContainer {
    width: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 2.778vh;
    padding-left: 16px;
  }

  .navbarIcon {
    height: 21px;
    width: 21px;
    color: #c4c4c4;
  }
  .navbarRoute {
    color: #c4c4c4;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-left: 10px;
  }
  .activeNavbarIcon {
    height: 21px;
    width: 21px;
    color: #fff;
  }
  .activeNavbarRoute {
    margin-left: 10px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
  .textMessage {
    color: #f7f7f7;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    padding-top: 10px;
    padding-left: 16px;
  }
  .notificationsIcon.mobile {
    display: none;
  }
  .venueContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 8px;
    left: 50%;
    transform: translateX(-50%);
  }

  @media only screen and (max-width: 724px) {
    .leftText,
    .pendingRequestCount {
      display: none;
    }
    .menuIcon {
      display: block;
      padding-right: 10px;
    }
    .notificationsIcon {
      display: none;
    }
    .notificationsIcon.mobile {
      display: block;
    }
  }
`;

function Header({ pendingSongRequestsList }) {
  const [showNav, setShowNav] = useState(false);
  const [active, setActive] = useState(window.location.pathname);
  const logoutRequest = useApi();
  useEffect(() => {
    if (
      logoutRequest.data &&
      logoutRequest.data.data &&
      logoutRequest.data.data.logout
    ) {
      route("/");
      removeCookie("user_key", window.location.host, "/");
      removeCookie("token", window.location.host, "/");
      removeCookie("user_id", window.location.host, "/");
      clearSessionStorage();
    }
  }, [logoutRequest.data]);
  const handleRoute = (routeparam) => {
    setActive(routeparam);
    route(routeparam);
  };

  const userLogout = () => {
    logoutApi(logoutRequest.request, {
      host: getSessionStorage("host"),
    });
  };
  const getCurrentMessage = () => {
    const currentTime = new Date();
    const currentHour = currentTime.getHours();
    if (currentHour < 12 && currentHour > 4) {
      return "Good Morning";
    } else if (currentHour >= 12 && currentHour < 16) {
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  };

  const [gotError, setGotError] = useState(false);
  const [currentVenue, setCurrentVenue] = useState();
  // const profileRequest = useApi();
  const liveVenueRequest = useApi();

  useEffect(() => {
    liveVenueApi(liveVenueRequest.request);
    // profileApi(profileRequest.request, getSessionStorage("host"));
  }, []);

  useEffect(() => {
    if (liveVenueRequest.data && liveVenueRequest.data.data) {
      setGotError(false);
      setCurrentVenue(liveVenueRequest.data.data.venue);
      setSessionStorage(
        "charge_customer",
        liveVenueRequest.data.data.charge_customer
      );
    }
  }, [liveVenueRequest.data]);

  // useEffect(() => {
  //   if (profileRequest.data && profileRequest.data.data) {
  //     setGotError(false);
  //     setCurrentVenue(profileRequest.data.data.venue);
  //   }
  // }, [profileRequest.data]);

  useEffect(() => {
    if (
      liveVenueRequest.error &&
      liveVenueRequest.errorBody?.response.data.status === 409
    ) {
      setCurrentVenue("");
      setGotError(true);
    }
  }, [liveVenueRequest.error]);

  const handleClickOutside = () => {
    setShowNav(false);
  };
  const navRef = useRef();
  useOnClickOutside(navRef, handleClickOutside);

  return (
    <Fragment>
      <ContentWrapper>
        {liveVenueRequest.loading || currentVenue == undefined ? (
          <div className="venueContainer">
            <p
              style={{
                width: "100%",
                minWidth: "max-content",
                display: "flex",
                padding: "4px 8px",
                borderRadius: "10px",
                background: "gray",
                fontSize: "14px",
                maxWidth: "70vw,",
              }}
            >
              Loading...
            </p>
          </div>
        ) : currentVenue.length > 0 ? (
          <div className="venueContainer">
            <p
              style={{
                width: "100%",
                padding: "4px 8px",
                borderRadius: "10px",
                background: "#6741d9",
                fontSize: "14px",
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "inline-block",
              }}
            >
              Live at {currentVenue}
            </p>
          </div>
        ) : (
          <div className="venueContainer">
            <p
              style={{
                width: "100%",
                minWidth: "max-content",
                display: "flex",
                padding: "4px 8px",
                borderRadius: "10px",
                background: "red",
                fontSize: "14px",
                maxWidth: "70vw,",
              }}
            >
              Not live at any Venue
            </p>
          </div>
        )}

        {showNav && (
          <div className="nav-menu" ref={navRef}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                padding: "20px 10px 10px 10px",
              }}
            >
              <img
                src={Logo}
                alt="Dhun Jam"
                style={{
                  width: "160px",
                  height: "auto",
                }}
              />
              <IconButton
                style={{
                  position: "absolute",
                  right: "5px",
                  top: "13px",
                }}
                onClick={() => {
                  setShowNav(false);
                }}
              >
                <Close style={{ color: "white" }} />
              </IconButton>
            </div>

            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <div className="textMessage">
                {getCurrentMessage()}, {getSessionStorage("host_name")}
              </div>
              <div
                className="userRoutes"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <div
                  className="navbarContainer"
                  onClick={() => {
                    handleRoute("/home/");
                  }}
                >
                  <HomeIcon
                    className={
                      active !== "/home/" ? "navbarIcon" : "activeNavbarIcon"
                    }
                  />
                  <div
                    className={
                      active !== "/home/" ? "navbarRoute" : "activeNavbarRoute"
                    }
                  >
                    Home
                  </div>
                </div>
                <div
                  className="navbarContainer"
                  onClick={() => {
                    handleRoute("/slots/");
                  }}
                >
                  <LibraryMusicIcon
                    className={
                      active !== "/slots/" ? "navbarIcon" : "activeNavbarIcon"
                    }
                  />
                  <div
                    className={
                      active !== "/slots/" ? "navbarRoute" : "activeNavbarRoute"
                    }
                  >
                    Slots
                  </div>
                </div>
                {/* <div
                  className="navbarContainer"
                  onClick={() => {
                    handleRoute("/requests/");
                  }}
                >
                  <AddBoxIcon
                    className={
                      active !== "/requests/"
                        ? "navbarIcon"
                        : "activeNavbarIcon"
                    }
                  />
                  <div
                    className={
                      active !== "/requests/"
                        ? "navbarRoute"
                        : "activeNavbarRoute"
                    }
                  >
                    Requests
                  </div>
                </div> */}
                <div
                  className="navbarContainer"
                  onClick={() => {
                    handleRoute("/played-songs/");
                  }}
                >
                  <LibraryAddCheckIcon
                    className={
                      active !== "/played-songs/"
                        ? "navbarIcon"
                        : "activeNavbarIcon"
                    }
                  />
                  <div
                    className={
                      active !== "/played-songs/"
                        ? "navbarRoute"
                        : "activeNavbarRoute"
                    }
                  >
                    Played
                  </div>
                </div>
                <div
                  className="navbarContainer"
                  onClick={() => {
                    handleRoute("/songs-list/");
                  }}
                >
                  <QueueMusicIcon
                    className={
                      active !== "/songs-list/"
                        ? "navbarIcon"
                        : "activeNavbarIcon"
                    }
                  />
                  <div
                    className={
                      active !== "/songs-list/"
                        ? "navbarRoute"
                        : "activeNavbarRoute"
                    }
                  >
                    Songs List
                  </div>
                </div>

                <div className="userStateRoutes">
                  <div
                    className="navbarContainer"
                    onClick={() => {
                      handleRoute("/profile/");
                    }}
                  >
                    {getSessionStorage("insta_pic") &&
                    getSessionStorage("insta_pic") != "null" ? (
                      <img
                        src={getSessionStorage("insta_pic")}
                        alt=""
                        className="image"
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "999px",
                        }}
                      />
                    ) : (
                      <img
                        src={ProfilePicture}
                        alt=""
                        className="image"
                        style={{
                          width: "25px",
                          height: "25px",
                          borderRadius: "999px",
                        }}
                      />
                    )}
                    <div
                      className={
                        active !== "/profile/"
                          ? "navbarRoute"
                          : "activeNavbarRoute"
                      }
                    >
                      Profile
                    </div>
                  </div>
                  <div
                    className="navbarContainer"
                    onClick={() => {
                      userLogout();
                    }}
                  >
                    <LogoutIcon className="navbarIcon" />
                    <div className="navbarRoute">Logout</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <IconButton
          className="menuIcon"
          style={{ padding: "4px 20px 0px 0px" }}
          onClick={() => {
            setShowNav(true);
          }}
        >
          <MenuIcon />
        </IconButton>
        <div className="leftText">
          {getCurrentMessage()}, {getSessionStorage("host_name")}
        </div>
        {
          <div className="rightText">
            {pendingSongRequestsList && (
              <div className="pendingRequestCount">
                {pendingSongRequestsList?.length !== 0
                  ? `${pendingSongRequestsList?.length} ${
                      pendingSongRequestsList?.length === 1
                        ? " Pending Request"
                        : " Pending Requests"
                    }`
                  : ""}
              </div>
            )}
            <div
              className="notificationsIcon mobile"
              style={{ padding: "8px" }}
            >
              <Badge badgeContent={pendingSongRequestsList?.length}>
                <NotificationsIcon style={{ color: "#fff" }} />
              </Badge>
            </div>
            <div
              className="notificationsIcon"
              style={{ padding: "4px 0px 0px 10px" }}
            >
              <NotificationsIcon style={{ color: "#fff" }} />
            </div>
          </div>
        }
      </ContentWrapper>
    </Fragment>
  );
}

export default Header;
